import { RestSchemas } from '@/contexts/QueryProvider'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/shadcn/avatar'

type MessagesLandingApplicationMarketingInfoCard = RestSchemas['Messages.Landing.ApplicationMarketingInfoCard']

export function AppMarketingInfoCard({ app }: { app: MessagesLandingApplicationMarketingInfoCard }) {
  return (
    <div className="mx-auto max-w-7xl space-y-12 rounded-2xl border p-6">
      {/* Hero Section */}
      <div className="grid grid-cols-[1fr_2fr] items-center">
        <div className="max-h-24 overflow-hidden rounded-lg shadow-md">
          <img src={app.image} alt={app.name} className="h-auto w-full object-cover shadow-sm" />
        </div>
        <div className="space-y-4 pl-16">
          <h1 className="text-2xl font-bold text-foreground">{app.name}</h1>
          <p className="max-w-3xl text-lg leading-relaxed text-muted-foreground">{app.description}</p>
        </div>
      </div>

      {/* Main Content Grid */}
      <div className="grid items-start gap-12 lg:grid-cols-2">
        {/* Left Column - Problem & Solution */}
        <div className="space-y-8">
          {/* Problem Statement */}
          <div className="space-y-4 rounded-lg border border-border bg-card p-6">
            <h2 className="text-2xl font-semibold text-card-foreground">The Challenge</h2>
            <p className="leading-relaxed text-muted-foreground">{app.problem_statement}</p>
            {app.key_questions && (
              <div className="pt-2">
                <h3 className="mb-2 text-sm font-medium text-card-foreground">Key Questions</h3>
                <p className="text-sm leading-relaxed text-muted-foreground">{app.key_questions}</p>
              </div>
            )}
          </div>

          {/* Solution */}
          <div className="space-y-4 rounded-lg border border-primary/20 bg-primary/5 p-6">
            <h2 className="text-2xl font-semibold text-foreground">Our Solution</h2>
            <p className="leading-relaxed text-muted-foreground">{app.solution_description}</p>
          </div>
        </div>

        {/* Right Column - Benefits & Contacts */}
        <div className="space-y-8">
          {/* Key Benefits */}
          {app.differentiators && app.differentiators.length > 0 && (
            <div className="space-y-6">
              <h2 className="text-2xl font-semibold text-foreground">Key Benefits</h2>
              <div className="grid gap-4">
                {app.differentiators.map((benefit, index) => (
                  <div
                    key={index}
                    className="flex items-start gap-4 rounded-lg border border-border bg-card p-4 transition-shadow hover:shadow-sm"
                  >
                    {benefit.image && (
                      <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-lg bg-primary/10">
                        <img src={benefit.image} alt="" className="h-6 w-6 object-contain" />
                      </div>
                    )}
                    <div className="flex-1">
                      <p className="font-medium leading-relaxed text-card-foreground">{benefit.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Contact Information */}
          {/* {app.application_leads && app.application_leads.length > 0 && (
            <div className="space-y-6">
              <h2 className="text-2xl font-semibold text-foreground">Get in Touch</h2>
              <div className="grid gap-4">
                {app.application_leads
                  .filter((lead) => lead.name && lead.contact_detail)
                  .map((lead, index) => (
                    <div key={index} className="flex items-center gap-4 rounded-lg border border-border bg-card p-4">
                      <Avatar className="h-12 w-12">
                        <AvatarImage src={lead.image || undefined} alt={lead.name} />
                        <AvatarFallback className="bg-primary/10 font-medium text-primary">
                          {lead.name
                            ?.split(' ')
                            .map((n) => n[0])
                            .join('')
                            .toUpperCase() || '?'}
                        </AvatarFallback>
                      </Avatar>
                      <div className="flex-1">
                        <p className="font-medium text-card-foreground">{lead.name}</p>
                        {lead.designation && <p className="text-sm text-muted-foreground">{lead.designation}</p>}
                        <a
                          href={`mailto:${lead.contact_detail}`}
                          className="text-sm text-primary transition-colors hover:text-primary/80"
                        >
                          {lead.contact_detail}
                        </a>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )} */}
        </div>
      </div>

      {app.application_leads && app.application_leads.length > 0 && (
        <div className="space-y-6">
          <h2 className="text-center text-2xl font-semibold text-foreground">Get in Touch</h2>
          <div className="grid grid-cols-[1fr_2fr] items-center">
            <div className="grid gap-4">
              {app.application_leads
                .filter((lead) => lead.name && lead.contact_detail)
                .map((lead, index) => (
                  <div key={index} className="flex items-center gap-4 rounded-lg border border-border bg-card p-4">
                    <Avatar className="h-12 w-12">
                      <AvatarImage src={lead.image || undefined} alt={lead.name} />
                      <AvatarFallback className="bg-primary/10 font-medium text-primary">
                        {lead.name
                          ?.split(' ')
                          .map((n) => n[0])
                          .join('')
                          .toUpperCase() || '?'}
                      </AvatarFallback>
                    </Avatar>
                    <div className="flex-1">
                      <p className="font-medium text-card-foreground">{lead.name}</p>
                      {lead.designation && <p className="text-sm text-muted-foreground">{lead.designation}</p>}
                      <a
                        href={`mailto:${lead.contact_detail}`}
                        className="text-sm text-primary transition-colors hover:text-primary/80"
                      >
                        {lead.contact_detail}
                      </a>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}

      {/* App Image */}
      {/* {app.image && (
        <div className="mt-12 rounded-xl border border-border bg-card p-8">
          <img src={app.image} alt={app.name} className="h-auto w-full rounded-lg shadow-sm" />
        </div>
      )} */}
    </div>
  )
}
